export enum Roles {
  SME = 'SME',
  Standard = 'Standard'
}
